import { bindActionCreators } from "@reduxjs/toolkit";
import AppWrapper from "components/board/AppWrapper";
import MainContent from "components/board/MainContent";
import MainHeader from "components/board/MainHeader";
import TableV8 from "components/table/TableV8";
import { parkdCardsSliceActions } from "features/parkdcards/parkdCardsSlice";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { ReduxState } from "types";
import { PARKD_CARDS_TABLE_DEFAULT_COLUMN_VISIBILITY, parkdCardsTableColumns, parkdCardsTableDefaultSorting } from "./parkdCardsTableColumns";


export const ParkdCardsScreen = (props: Props) => {

    const { paging, getStatus, parkdCards } = props;

    return (
        <AppWrapper>
            <main id="page-parkd-cards" className="col-main">
                <MainHeader>
                    <div className="header-v-align">
                        <h2 className="main-header-title">
                            <FormattedMessage id="MANAGE_PARKD_CARDS" />
                            &nbsp;
                            {!!paging?.totalElements && `(${paging?.totalElements})`}
                        </h2>
                    </div>
                </MainHeader>

                <MainContent>
                    <div className="board-content radius-rectangle no-overflow">
                        <TableV8
                            data={parkdCards}
                            status={getStatus}
                            columns={parkdCardsTableColumns}
                            defaultSorting={parkdCardsTableDefaultSorting}
                            columnVisibility={PARKD_CARDS_TABLE_DEFAULT_COLUMN_VISIBILITY}
                            pagination={paging}
                            fetchData={props.getParkdCards}
                        />
                    </div>
                </MainContent>

            </main>
        </AppWrapper>
    )
}


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

function mapStateToProps(state: ReduxState) {
    return {
        parkdCards: state.parkdCards.parkingCards,
        paging: state.parkdCards.paging,
        getStatus: state.parkdCards.getStatus
    };
}

function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        getParkdCards: parkdCardsSliceActions.getParkdCards
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkdCardsScreen);